import type { Location } from 'react-router-dom';

import { HOME, LOGIN, PASSWORD_RECOVERY } from 'router/routes';

/**
 * Resolves where to send the user after login. Only same-app relative paths are allowed.
 */
export function getPostLoginRedirectPath(
  from: Pick<Location, 'pathname' | 'search'> | undefined,
  fallback: string = HOME,
): string {
  if (!from?.pathname) return fallback;

  const { pathname, search } = from;
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return fallback;
  if (pathname === LOGIN || pathname === PASSWORD_RECOVERY) return fallback;

  return `${pathname}${search ?? ''}`;
}
